/* PastéBCN — Footer
   Web Component <pb-footer>: IntersectionObserver para animación de entrada
   (fade + translateY con stagger CSS). No toca el form newsletter — Shopify
   lo procesa nativamente con {% form 'customer' %}. Respeta reduced-motion. */

if (!customElements.get('pb-footer')) {
  class PbFooter extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
        this.classList.add('is-visible');
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              this._observer.disconnect();
            }
          });
        },
        { threshold: 0.1 }
      );
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
  }

  customElements.define('pb-footer', PbFooter);
}
